import styled from "styled-components";

import { typographies } from "../../../styles/figmaTypographies";

export const Brand = () => <StyledBrand>Qivia</StyledBrand>;

const StyledBrand = styled.span`
  ${typographies["Header/H2"]}
  color: inherit;
`;
